import React, { useState, useEffect, useRef } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import {
  Grid,
} from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import { i18n } from "../../translate/i18n";
import TextField from "@material-ui/core/TextField";
import api from "../../services/api";
import { Autocomplete } from "@mui/material";
import Chip from "@mui/material/Chip";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const FlowBuilderAddSwitchFlowModal = ({
  open,
  onSave,
  onUpdate,
  data,
  close,
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const initialState = {
    message: "",
    answerKey: "",
  };

  const [message, setMessage] = useState();
  const [activeModal, setActiveModal] = useState(false);
  const [integration, setIntegration] = useState();
  const [flowsData, setFlowsData] = useState([]);
  const [flowsDataObject, setFlowsDataObj] = useState([]);
  const [flowSelected, setFlowSelected] = useState();
  const [name, setName] = useState("");

  const [labels, setLabels] = useState({
    title: i18n.t("flowBuilder.switch.addTitle") || "Adicionar Troca de Fluxo",
    btn: i18n.t("common.add") || "Adicionar",
  });

  useEffect(() => {
    getFlows();
    if (open === "edit") {
      setLabels({
        title: i18n.t("flowBuilder.switch.editTitle") || "Editar Troca de Fluxo",
        btn: i18n.t("common.save"),
      });

      console.log(data?.data?.flowSelected?.name);
      setFlowSelected(data?.data?.flowSelected?.name || "");
      setName(data?.data?.name || "");
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({
        title: i18n.t("flowBuilder.switch.addTitle") || "Adicionar Troca de Fluxo",
        btn: i18n.t("common.add") || "Adicionar",
      });

      setFlowSelected("");
      setName("");
      setActiveModal(true);
    }

    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const getFlows = async () => {
    return await api.get("/flowbuilder").then((res) => {
      if (isMounted.current) {
        // Filter out invalid flows and map
        const validFlows = res.data.flows.filter(flow => flow && flow.name);
        setFlowsData(validFlows.map((flow) => flow.name));
        setFlowsDataObj(validFlows);
      }
      return res.data.flows;
    });
  };

  const handleSaveContact = (values) => {
    if (open === "edit") {
      handleClose();
      const selected = flowsDataObject.find(
        (flow) => flow?.name === flowSelected
      );
      onUpdate({
        ...data,
        data: { ...data.data, flowSelected: selected, name: name },
      });
    } else if (open === "create") {
      const selected = flowsDataObject.find(
        (flow) => flow?.name === flowSelected
      );
      handleClose();
      onSave({
        flowSelected: selected,
        name: name,
      });
    }
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {open === "create"
            ? i18n.t("flowBuilder.switch.addTitle") || "Adicionar Troca de Fluxo"
            : i18n.t("flowBuilder.switch.editTitle") || "Editar Troca de Fluxo"}
        </DialogTitle>
        <DialogContent dividers>
          <Grid style={{ with: "100%", marginTop: 10, height: "250px" }}>
            {flowsDataObject && flowsDataObject.length && (
              <>
                <TextField
                  label={i18n.t("flowBuilder.form.name") || "Nome"}
                  variant="outlined"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
                  className={classes.textField}
                  style={{ marginBottom: 10 }}
                />
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  value={flowSelected}
                  options={flowsData}
                  onChange={(event, newValue) => {
                    setFlowSelected(newValue);
                  }}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder={i18n.t("flowBuilder.switch.selectFlow") || "Escolha um fluxo"}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        variant="outlined"
                        label={option}
                        {...getTagProps({ index })}
                        style={{ borderRadius: "8px" }}
                      />
                    ))
                  }
                />
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" style={{ borderColor: "#ff4d4f", color: "#ff4d4f", textTransform: "none", fontWeight: "bold", borderRadius: "8px" }}>{i18n.t("common.cancel") || "Cancelar"}</Button>
          <Button type="submit" onClick={handleSaveContact}  variant="contained" style={{ backgroundColor: "#7367F0", color: "#fff", textTransform: "none", fontWeight: "bold", borderRadius: "8px", boxShadow: "0 4px 14px 0 rgba(115, 103, 240, 0.39)" }}>{open === "create" ? (i18n.t("common.add") || "Adicionar") : (i18n.t("common.save") || "Salvar")}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddSwitchFlowModal;
